export const formFields = [
    {
      type: 'text',
      name: 'beneficiaryIban',
      id: 'beneficiaryIban',
      placeholder: 'Εισάγετε IBAN',
      size: 'large',
      maxLength: 27,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        ({ getFieldValue }) => ({
        validator() {
          const iban = getFieldValue('beneficiaryIban');
          if (iban.length < 27) {
            return Promise.reject([
              'To iban πρέπει να είναι 27 ψηφία',
            ]);
          }
          return Promise.resolve();
        },
      }),],
    }
]